import { Comment, StoryCard } from '../../services';

interface HideCommentReducerArgs {
  card: StoryCard;
  comment: Comment;
}

export const hideCommentReducer = ({ card, comment }: HideCommentReducerArgs) => {
  const { comments } = card;
  const { id, parentId, isHidden } = comment;

  const commentsToUpdate = parentId
    ? comments.find(({ id }) => id === parentId)?.replies
    : comments;

  if (!commentsToUpdate) {
    return;
  }

  const commentToUpdate = commentsToUpdate.find((comment) => comment.id === id);

  if (!commentToUpdate) {
    return;
  }

  commentToUpdate.isHidden = isHidden;
};
